import React, { useState, useRef, useEffect, memo } from "react";
import useStyles from "./styles";
import clsx from "clsx";
import CancelIcon from "@material-ui/icons/Cancel";

import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import { Images } from "config/images";

const InputSearchProduct = props => {
	const classes = useStyles();
	const { valueSearch, handleSearchProduct } = props;
	const inputRef = useRef(null);

	useEffect(() => {
		setSearch(!!valueSearch);
	}, [valueSearch]);

	const [isSearch, setSearch] = useState(false);
	const handleSearch = value => {
		handleSearchProduct(value);
		setSearch(!!value);
	};

	return (
		<TextField
			InputProps={{
				startAdornment: (
					<InputAdornment
						position="start"
						className={classes.inputAdornment}
					>
						<img
							src={Images.icMagnifyingGlass}
							alt={"icMagnifyingGlass"}
							style={{ padding: 7 }}
						/>
					</InputAdornment>
				),
				endAdornment: isSearch && (
					<InputAdornment position="end">
						<IconButton
							onClick={() => {
								handleSearch("");
								inputRef.current.value = "";
							}}
						>
							<CancelIcon style={{ color: "#959595" }} />
						</IconButton>
					</InputAdornment>
				)
			}}
			inputRef={inputRef}
			defaultValue={valueSearch}
			className={clsx(classes.customInput)}
			placeholder="Tìm sản phẩm bạn muốn mua hôm nay"
			onChange={event => {
				if (event.target.value === "") {
					handleSearch(event.target.value);
				}
			}}
			onKeyPress={event => {
				if (event.key === "Enter") {
					event.target.blur();
					handleSearch(event.target.value);
				}
			}}
		/>
	);
};

export default memo(InputSearchProduct);
